window._ = require('lodash');
window.intlTelInput = require('intl-tel-input');
window.Cookies = require('js-cookie');
window.ClipboardJS = require('clipboard');
window.tus = require("tus-js-client");
window.AOS = require("aos");
import swal from 'sweetalert';

try {
    AOS.init();
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;
    require('bootstrap');
    require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min');
    require('select2/dist/js/select2.full.min');
    require('select2/dist/js/i18n/ru');
    require('jquery-lazy');
    require('readmore-js');
    require('jquery-ui/ui/widget');
    require('blueimp-file-upload/js/jquery.fileupload');

    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        }
    });
} catch (e) {
    console.log(e);
}
